var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.isAuthenticated)?_c('button',{on:{"click":_vm.logout}},[_vm._v("Log Out")]):_c('p',[_vm._v("Not Authenticated")])
}
var staticRenderFns = []

export { render, staticRenderFns }